import React from "react";
import { withRouter, useHistory } from "react-router-dom";
import Main from "./main";
import { ReportStore } from "./contexts";
import _ from "lodash";

function Context(props) {
  const page = "home";
  const history = useHistory();
  const { pageList, homepage } = props.Pages;
  const auth = _.find(pageList, (o) => {
    return o.value === page;
  });
  if (props.companychanged || !props.currentcompany || !auth)
    history.push("/" + homepage);

  return (
    <ReportStore>
      <Main {...props} />
    </ReportStore>
  );
}

export default withRouter(Context);
